var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.959 4.625L15.9375 4.9855C11.9619 6.38867 9.97412 7.09025 8.84155 8.69102C7.70898 10.2918 7.70898 12.3998 7.70898 16.6158V20.3842C7.70898 24.6002 7.70898 26.7081 8.84155 28.309C9.97412 29.9097 11.9619 30.6113 15.9375 32.0146L16.959 32.375",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3757 18.5H16.959M32.3757 18.5C32.3757 17.4206 29.3011 15.4036 28.5215 14.6459M32.3757 18.5C32.3757 19.5795 29.3011 21.5965 28.5215 22.3542",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cc5c8f3105aa390ad28282cd8d8afd63.svg";
export { ForwardRef as ReactComponent };